export enum ProjectStatus {
  IN_PROGRESS = 'IN PROGRESS',
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING',
  EXPIRED = 'EXPIRED'
}
